import { useEffect, useState } from "react";

/**
 * Detects on-screen keyboard via VisualViewport API.
 * Toggles a `keyboard-open` class on document.body so CSS can react globally.
 * Returns boolean flag for components that need it.
 */
export default function useKeyboardOpen() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const onResize = () => {
      // Heuristic: if the visual viewport is significantly smaller than the layout viewport, keyboard is open
      const isOpen = window.innerHeight - vv.height > 150;
      setOpen(isOpen);
      document.body.classList.toggle("keyboard-open", isOpen);
    };
    vv.addEventListener("resize", onResize);
    vv.addEventListener("scroll", onResize);
    return () => {
      vv.removeEventListener("resize", onResize);
      vv.removeEventListener("scroll", onResize);
      document.body.classList.remove("keyboard-open");
    };
  }, []);

  return open;
}
